
// config/apiConfig.js
export const API_CONFIG = {
    // Change this for different builds
    DEFAULT_ENVIRONMENT: "prod", // "dev", "qa", or "prod"

    VERSION: "1.0.0",
    DEBUG: true,
}